import React, { useContext, useState } from "react";
import { ModalServiceContext, RicosContext } from "./../../ricos-context";
import { PluginSettingsIcon } from "./../../plugin-commons";
import { ToggleButton } from "./../../toolbars-ui";
const LinkPreviewSettingsButton = ({ toolbarItem, dataHook }) => {
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useContext(ModalServiceContext) || {};
  const [referenceElement, setReferenceElement] = useState(null);
  return /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      Icon: PluginSettingsIcon,
      onClick: () => toolbarItem.commands?.click({ modalService, isMobile, referenceElement }),
      dataHook,
      tooltip: t("LinkPreview_Settings_Tooltip"),
      setRef: setReferenceElement
    }
  );
};
export {
  LinkPreviewSettingsButton
};
//# sourceMappingURL=SettingsButton.js.map
